// removed by extract-text-webpack-plugin
module.exports = {"secondaryNavbar":"_2Znnb","topCategoryLinks":"_3LN_G","phone":"owlAA","active":"_1NNI5","overlay":"_2dYSn","innerContainer":"_2SUHm","maxHeight":"_2KbeU","subCategoryLinks":"oGwsl","parent":"_4xRz9","child":"_9I6nt"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/SecondaryNavbar/index.sass
// module id = 1487
// module chunks = 1